import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PersonalCardView from '../PersonalInformation/PersonalCardView';
import PersonalInformation from '../PersonalInformation';
import CompanyCardView from '../CompanyInformation/CompanyCardView';
import CompanyInformation from '../CompanyInformation';
import ChangePassword from '../ChangePassword';
import DiamondColumnListing from '../ManageDiamondSequence';
import '../../common/Tab/tab.less';
import { Drawer } from 'antd';
import IntlMessages from '../../../util/IntlMessages';
import KycProof from '../KycProof';
import { LOCAL_STORAGE_VAR, KYC_STATUS } from '../../../constants/Common';
import { GET_DASHBOARD_DATA, FETCH_USER } from '../../../constants/apiConstant';
import UtilService from '../../../services/util';
import StockNotification from './StockNotification/StockNotification';
import { store } from 'appRedux/store/index';

class Profile extends Component {
  state = {
    visible: false,
    visible1: false,
    visible2: false,
    user: {},
    isUploaded: false,
    imageTwo: '',
    imageOne: '',
    isApproved: KYC_STATUS.PENDING,
  };
  componentDidMount() {
    this.fetchUser();
  }
  getKycDetail = () => {
    const userData = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);
    const obj = {
      ...GET_DASHBOARD_DATA, request: {
        accountView: true, account: true,
        labGrown: store.getState().commonData.labGrown,
      }
    };
    UtilService.callApi(obj, (err, data) => {
      if (err) {
        this.setState({ dashData: undefined, visible: false });
      } else if (data && data.code === 'OK') {
        // console.log("dt=====", data);
        if (data.data && data.data.account) {
          userData.account = data.data.account;
          UtilService.setLocalStorageItem(userData, `${LOCAL_STORAGE_VAR}-user`);
          if (data.data.account.isKycUploaded) {
            if (data.data.account.kyc && data.data.account.kyc.length >= 2) {
              this.setState({
                user: userData,
                isUploaded: true,
                imageTwo: data.data.account.kyc[0].path,
                imageOne: data.data.account.kyc[1].path,
                isApproved: data.data.account.isApproved,
              });
            }
          }
        }
      } else {
        this.setState({ dashData: undefined, visible: false });
      }
    });
  };

  fetchUser() {
    UtilService.callApi(FETCH_USER, (err, res) => {
      this.getKycDetail();
      if (res && res?.code === 'OK') {
        const userData = res.data;
        UtilService.setLocalStorageItem(userData, `${LOCAL_STORAGE_VAR}-user`);
        return;
      }

      if (err && err?.data?.code === 'E_BAD_REQUEST') return null;
    });
  }

  showDrawer = () => this.setState({ visible: true });

  showDrawer1 = () => this.setState({ visible1: true });

  onClose = () => void this.setState({ visible: false, visible1: false, visible2: false });

  render() {
    const { user, isUploaded, imageTwo, imageOne, isApproved } = this.state;
    return (
      <div>
        <div className="">
          <Tabs defaultIndex={window.location.search === '?notification' ? 6 : ''} className="accountTabBox">
            <TabList className="customerMaintab accountSubTab">
              <Tab>
                <IntlMessages id="app.PersonalInformation" />
              </Tab>
              <Tab>
                <IntlMessages id="app.CompanyInformation" />
              </Tab>
              <Tab>KYC</Tab>
              {/* <Tab>Manage User</Tab> */}
              {/* <Tab>Manage Addresses</Tab> */}
              <Tab>
                <IntlMessages id="app.ChangePassword" />
              </Tab>
              <Tab>
                <IntlMessages id="app.ManageDiamondSequence" />
              </Tab>
              <Tab>
                <IntlMessages id="app.StockNotification" />
              </Tab>
            </TabList>
            <TabPanel>
              <PersonalCardView onClose={this.onClose} onClick={this.showDrawer} />
            </TabPanel>
            <TabPanel>
              <CompanyCardView onClose={this.onClose} onClick={this.showDrawer1} />
            </TabPanel>
            <TabPanel>
              <KycProof
                isApproved={isApproved}
                isUploaded={isUploaded}
                imageOne={imageOne}
                imageTwo={imageTwo}
                user={user}
              />
            </TabPanel>
            {/* <TabPanel>
              <ManageUser />
            </TabPanel> */}
            {/* <TabPanel>
              <ManageAddress />
            </TabPanel> */}
            <TabPanel>
              <ChangePassword />
            </TabPanel>
            <TabPanel>
              <DiamondColumnListing />
            </TabPanel>
            <TabPanel>
              <StockNotification />
            </TabPanel>
          </Tabs>
        </div>
        <Drawer
          title={false}
          onClose={this.onClose}
          visible={this.state.visible}
          wrapClassName="diamondListinSidebar profileSidebar"
        >
          <PersonalInformation onClose={this.onClose} />
        </Drawer>
        <Drawer
          title={false}
          onClose={this.onClose}
          visible={this.state.visible1}
          wrapClassName="diamondListinSidebar profileSidebar"
        >
          <CompanyInformation onClose={this.onClose} />
        </Drawer>
      </div>
    );
  }
}

export default withRouter(Profile);
